<template>
  <w-perf-widget :show-change-btn="false">
    <span slot="perfHeader">이벤트 정보</span>
    <ul class="event-info-list" slot="perfBody">
      <li class="status-red">
        <span class="status c-pointer" @click="routeEventMenu('event-status')">{{eventInfoData.todayEventCount}}</span><span>이벤트 발생 건 수</span>
      </li>
      <!-- <li>
        <span class="status">{{eventInfoData.unconfirmedEventCount}}</span><span>미확인 이벤트 수</span>
      </li> -->
      <li class="status-blue">
        <span class="status c-pointer" @click="routeEventMenu('trouble-ticket')">{{eventInfoData.errorTicketCount}}</span><span>장애티켓 발행 수</span>
      </li>
    </ul>
    <template slot="perfFooter">
      <!-- 장비 관련 작업 여부 -->
      <span>작업 여부 <strong>{{ workLabel }}</strong></span>
      <span class="right-side">
        <ul class="icon-group-event">
          <li v-for="eventlevel in eventInfoData.eventCountList" :key="eventlevel.eventlevel_id">
            <span class="icon-dot" :style="{'background-color': eventlevel.eventlevel_color_bg}"></span>{{eventlevel.eventlevelCount}}
          </li>
        </ul>
      </span>
    </template>
  </w-perf-widget>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import WPerfWidget from '../components/PerfWidget';
import WPerfBodyInfo from '../components/PerfBodyInfo';

export default {
  name: 'WEventInfoWidget',
  components: {
    WPerfWidget,
    WPerfBodyInfo,
  },
  props: {
    eventInfoData: {
      type: Object,
      default() {
        return { todayEventCount: 0, unconfirmedEventCount: 0, errorTicketCount: 0, eventCountList: [], deviceWorkCount: {} };
      },
    },
  },
  computed: {
    workLabel() {
      let label = '';
      if (!isEmpty(this.eventInfoData.deviceWorkCount)) {
        const deviceWorkCount = this.eventInfoData.deviceWorkCount;
        if (deviceWorkCount.workCount === 0) {
          label = '현재 진행중인 작업이 없습니다.';
        } else {
          label = `[${deviceWorkCount.workName}]`;
          if (deviceWorkCount.workCount > 1) label += ` 외 ${deviceWorkCount.workCount - 1}개`;
          label += ' 작업이 진행중입니다.';
        }
      }
      return label;
    },
    selectedNode() {
      return this.$store.getters.selectedNode;
    },
  },
  methods: {
    /**
     * 트리에서 선택한 장비 기준으로 이벤트 메뉴로 이동한다.
     * 파라미터로 전달한 탭이 자동으로 선택되도록 한다.
     * @author Ju
     * @param  {String} tabName 이동할 이벤트 탭
     */
    routeEventMenu(tabName) {
      routePathByObjId(this, this.selectedNode.obj.objId, menuDefine.EVENT, tabName);
    },
  },
};
</script>

<style module>
.eventlevel-count {
  display: inline;
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/EventInfoWidget.vue